/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Network_InspectorInputs */

const en_mobile_network_inspector = /** @type {(inputs: Mobile_Network_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network inspector`)
};

const es_mobile_network_inspector = /** @type {(inputs: Mobile_Network_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector de red`)
};

/**
* | output |
* | --- |
* | "Network inspector" |
*
* @param {Mobile_Network_InspectorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_network_inspector = /** @type {((inputs?: Mobile_Network_InspectorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Network_InspectorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_network_inspector(inputs)
	return en_mobile_network_inspector(inputs)
});